import React from 'react';
import { motion } from 'framer-motion';
const problems = [{
  emoji: '🤷‍♀️',
  text: 'No sé cómo estimular a mi hijo de forma correcta'
}, {
  emoji: '⏰',
  text: 'No tengo tiempo ni dinero para terapias costosas'
}, {
  emoji: '🥺',
  text: 'Me preocupa que su desarrollo no vaya al ritmo adecuado'
}];
export function Problem() {
  return <section className="py-20 px-4 bg-white" data-id="element-74">
      <div className="max-w-5xl mx-auto" data-id="element-75">
        <div className="text-center mb-16" data-id="element-76">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-dark mb-6" data-id="element-77">
            ¿Te sientes identificada con esto? 🤔
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-78">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-pastel-pink/30 p-8 rounded-3xl text-center border-2 border-pastel-pink hover:shadow-xl transition-shadow" data-id="element-79">
              <div className="text-6xl mb-6" data-id="element-80">{problem.emoji}</div>
              <p className="text-xl font-medium text-gray-800" data-id="element-81">
                {problem.text}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-82">
          <p className="text-2xl font-display text-brand-purple font-bold" data-id="element-83">
            ¡No te preocupes! Es completamente normal y tenemos la solución. ✨
          </p>
        </div>
      </div>
    </section>;
}